<template>
  <div>
    <v-btn-toggle
      mandatory
      style="width: 100%"
      v-if="$vuetify.breakpoint.smAndUp"
    >
      <v-btn
        large
        v-for="(item, i) in items"
        :key="`${item.status}--${i}`"
        @click="setSelectStatus(item.status)"
        style="flex: 1"
      >
        <v-icon left :color="handleColorStatus(item.status)" size="10"
          >mdi-circle</v-icon
        >
        {{ item.text }}
      </v-btn>
    </v-btn-toggle>
    <v-select
      v-else
      v-model="select"
      :items="items"
      @change="setSelectStatus"
      item-text="text"
      item-value="status"
      :label="$t('statusEvent')"
      prepend-icon="mdi-list-status"
      dense
      filled
      hide-details
      solo-inverted
    ></v-select>
  </div>
</template>
<script>
export default {
  name: "components-common-filters-select-status",
  data: () => ({
    select: {},
  }),
  computed: {
    items() {
      return [
        { text: this.$t("doActives"), status: 1 },
        { text: this.$t("cancelledsMasc"), status: 2 },
        { text: this.$t("postponed"), status: 3 },
        { text: this.$t("didSuspended"), status: 4 },
      ];
    },
  },
  methods: {
    setSelectStatus(status) {
      // Set Store
      this.$store.commit("setSelectStatusEvents", status);
    },
    handleColorStatus(status) {
      if (status == 1) return "green";
      if (status == 2) return "purple";
      if (status == 3) return "orange";
      if (status == 4) return "red";
    },
  },
};
</script>
